import React, { useEffect } from 'react';
import { Layout, Button, Row, Col, Space } from 'antd';
import firebase from 'firebase/compat/app';
import { signInWithGoogle } from '../firebase/functions'; // or define inline
import logo3 from '../assets/images/Google__G__Logo.svg.png';
import { useHistory } from 'react-router-dom';

const {  Content } = Layout;

export default function SignIn(props) {
  const navigate = useHistory();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    // await logout();
    firebase.auth().onAuthStateChanged((user) => console.log('auth user [from SignIn useEffect] = ', user));
  }, []);

  // const logout = async () => {
  //   return await firebase.auth().signOut();
  // };

  return (
    <>
      <Layout className="layout-default layout-signin">
        <Content className="signin">
          <Row gutter={[24, 0]} justify="center" align="middle">
            <Col xs={{ span: 24, offset: 0 }} lg={{ span: 5, offset: 0 }} md={{ span: 12 }}>
                <div className="sign-up-gateways">
                  <Button
                    type="secondary"
                    block
                    onClick={() => signInWithGoogle(navigate)}
                    style-={{
                      marginBottom: 30,
                      padding: 10,
                    }}>
                    <Space style={{ height: '100%' }}>
                      <img src={logo3} alt="logo 3" style={{ height: 27 }} />
                      <span>Sign in with Google</span>
                    </Space>
                  </Button>
                </div>
            </Col>
          </Row>
        </Content>

      </Layout>
    </>
  );
}
